import React, { useEffect, Suspense, lazy, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import Favicon from 'react-favicon';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import WebLayout from 'layout/WebLayout';
import Loading from 'components/Loading';

import { convertGSToDownloadURL } from 'utils';
import buildMatch from 'utils/buildMatch';

const Console = lazy(() => import('modules/Web/container/Console'));

const BodyStyle = createGlobalStyle`
  body {
    overflow-y: hidden !important;
  }
`;

const WebConsolePage = ({ teams, user, matchpath }) => {
  const location = useLocation();
  const params = useParams();
  const match = buildMatch(location, params, matchpath);
  const navigate = useNavigate();

  const {
    params: { projectID, pageID, versionID },
  } = match;

  const [favicon, setFavicon] = useState('');

  const getOwnedTeam = useCallback(() => {
    if (teams && teams.length) {
      return teams?.find((t) => t.owner === user.uid) || teams[0];
    }

    return null;
  }, [teams, user]);

  useEffect(() => {
    const team = getOwnedTeam();

    if (team) {
      const { isDisabled, customBranding, theme } = team;

      if (isDisabled === false && customBranding && theme.iconURL) {
        if (theme.iconURL.startsWith('gs://')) {
          setFavicon(convertGSToDownloadURL(theme.iconURL, false));
        }
      } else {
        setFavicon('/favicon.ico');
      }
    } else {
      setFavicon('/favicon.ico');
    }
  }, [getOwnedTeam]);

  useEffect(() => {
    if (!projectID || !pageID) navigate('/projects');
  }, [projectID, pageID, navigate]);

  return (
    <WebLayout match={match}>
      <Favicon url={favicon} />
      <Suspense fallback={<Loading />}>
        <BodyStyle />
        <Console
          match={match}
          projectID={projectID}
          pageID={pageID}
          versionID={versionID}
        />
      </Suspense>
    </WebLayout>
  );
};

const mapStateToProps = ({ user: { user }, team: { teams } }) => ({
  user,
  teams,
});

WebConsolePage.propTypes = {
  user: PropTypes.object.isRequired,
  teams: PropTypes.array,
  matchpath: PropTypes.string,
};

export default connect(mapStateToProps)(WebConsolePage);
